import { api } from '.';

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

export const inserirSecretaria = async (params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };

    const response = await api.post('/secretarias/inserir', params, { headers });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const editarSecretaria = async (id: any, params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.put(`/secretarias/editar/${id}`, params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao editar secretaria';
    throw new Error(errorMessage);
  }
};

export const deletarSecretariaAssociada = async (codSecretaria: number, seqConteudo: number ) => {
  try {
    const response = await api.delete(`/conteudo/deletarSecretaria?codSecretaria=${codSecretaria}&seqConteudo=${seqConteudo}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao deletar secretaria associada';
    throw new Error(errorMessage);
  }
};

export const obterSecretaria = async (id: number) => {
  try {
    const response = await api.get(`/secretarias/obter/${id}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter secretaria';
    throw new Error(errorMessage);
  }
};

export const listarSecretariasAtivas = async (params?: string) => {
  try {
    const url = params ? `/secretarias/ativas${params}` : '/secretarias/ativas';
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const listarSecretarias = async (
  page: number,
  size: number,
  params?: Record<string, string | number>,
  axiosOpts?: { signal?: AbortSignal }
) => {
  try {
    const response = await api.get(`/secretarias/listar`, {
      params: {
        pagina: page,
        tamanhoPagina: size,
        ...params,
      },
      signal: axiosOpts?.signal,
    });

    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    throw apiError.response
      ? apiError.response.data
      : new Error("Erro ao listar secretarias");
  }
};
